import { render, staticRenderFns } from "./SearchBloc.vue?vue&type=template&id=bb0abe5a"
import script from "./SearchBloc.vue?vue&type=script&lang=js"
export * from "./SearchBloc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports